import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import ReportAbuseForm from '../../components/report-abuse-form';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

export const ReportPostModal = ({ closeModal, postId, reportPost, t }) =>
  <Modal onClose={closeModal}>
    <ReportAbuseForm
      initialValues={{ _id: postId, reportType: '1' }}
      onSubmit={reportPost}
      onCancel={closeModal}
      title={t('report-post-modal.report-post')}
      message={t('report-post-modal.help-us-understand')}
    />
  </Modal>;

ReportPostModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  reportPost: PropTypes.func.isRequired,
  postId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      closeModal,
      reportPost: report => closeModal(report),
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(withTranslate(ReportPostModal));



// WEBPACK FOOTER //
// ./app/containers/report-post-modal/report-post-modal.js